import React, { useLayoutEffect, useRef, useState } from 'react'
import '../../../../css/livepreview.scss'

// Fills its parent with an interactive render of the student UI. The student layouts are
// built for a full browser window, so below `minWidth` the render keeps that width and is
// scaled down to fit instead of reflowing into a layout students never see. Above it, the
// render simply takes the available size (scale 1). Height always fills the parent.
//
// Fully interactive: clicks, typing and scrolling work through the scale (CodeMirror 6.43
// handles transformed ancestors).
const FitViewport = ({ minWidth = 1100, children }) => {
  const hostRef = useRef(null)
  const [box, setBox] = useState({ width: 0, height: 0 })

  useLayoutEffect(() => {
    const host = hostRef.current
    if (!host) return undefined
    const update = () => setBox({ width: host.clientWidth, height: host.clientHeight })
    update()
    if (typeof ResizeObserver === 'undefined') return undefined
    const observer = new ResizeObserver(update)
    observer.observe(host)
    return () => observer.disconnect()
  }, [])

  const scale = box.width > 0 ? Math.min(1, box.width / minWidth) : 1
  const stageWidth = scale < 1 ? minWidth : box.width
  const stageHeight = box.height > 0 ? box.height / scale : 0

  return (
    <div className="lp-fit" ref={hostRef}>
      {box.width > 0 && (
        <div
          className="lp-fit__stage"
          style={{ width: stageWidth, height: stageHeight, transform: `scale(${scale})` }}>
          {children}
        </div>
      )}
    </div>
  )
}

export default FitViewport
